<elcia-card>
  <div class="flex h-full min-w-0 flex-col gap-2">

  <div class="flex flex-wrap items-baseline justify-between gap-x-2">
    <div class="flex items-center gap-2">
      <span aria-hidden="true" class="pi pi-euro flex-none text-sm text-[var(--p-surface-400)]"></span>
      <span class="text-xs text-[var(--p-surface-600)]">{{ 'dashboard.invoicing.title' | translate }}</span>
    </div>
    <!-- These amounts are company-wide: an invoice carries no author, so saying so avoids reading
         them as personal figures. -->
    <span class="rounded-full bg-[var(--p-surface-100)] px-2 py-0.5 text-[0.65rem] text-[var(--p-surface-500)]">
      {{ 'dashboard.invoicing.company-scope' | translate }}
    </span>
  </div>

  @if (isLoading()) {
    <div class="flex flex-1 items-center justify-center py-6">
      <elcia-loader/>
    </div>
  } @else {
    <div class="min-h-0 flex-1">
      <p-chart [data]="data()" [options]="options()" height="100%" type="bar"/>
    </div>
    @if (draftCount() > 0) {
      <span class="truncate text-xs text-[var(--p-surface-500)]">
        {{ 'dashboard.invoicing.draft-count' | translate: {count: draftCount()} }}
      </span>
    }
  }
  </div>
</elcia-card>
